import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function e(e, n, i) {
  var o = n.flatten(function (_ref) {
    var e = _ref.sublayers;
    return e;
  }).length;
  if (o !== e.length) return !0;
  return !!e.some(function (e) {
    return e.originIdOf("minScale") > i || e.originIdOf("maxScale") > i || e.originIdOf("renderer") > i || e.originIdOf("labelingInfo") > i || e.originIdOf("opacity") > i || e.originIdOf("labelsVisible") > i || e.originIdOf("source") > i;
  }) || !r(e, n);
}

function n(e, n, i) {
  return !!e.some(function (e) {
    var n = e.source;
    return !(!n || "map-layer" === n.type && n.mapLayerId === e.id && (!n.gdbVersion || n.gdbVersion === i.gdbVersion)) || e.originIdOf("renderer") > 2 || e.originIdOf("labelingInfo") > 2 || e.originIdOf("opacity") > 2 || e.originIdOf("labelsVisible") > 2;
  }) || !r(e, n);
}

function r(e, n) {
  if (!e || !e.length) return !0;
  var r = n.slice().reverse().flatten(function (_ref2) {
    var e = _ref2.sublayers;
    return e && e.toArray().reverse();
  }).map(function (e) {
    return e.id;
  }).toArray();
  if (e.length > r.length) return !1;
  var i = 0;
  var o = r.length;

  var _iterator = _createForOfIteratorHelper(e),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var t = _step.value.id;

      for (; i < o && r[i] !== t;) {
        i++;
      }

      if (i >= o) return !1;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return !0;
}

function i(e) {
  return !!e && e.some(function (e) {
    return null != e.minScale || e.layerDefinition && null != e.layerDefinition.minScale;
  });
}

export { n as isExportDynamic, i as isSublayerOverhaul, e as shouldWriteSublayerStructure };